import { Link } from "react-router-dom";
import { ArrowRight, Upload, Phone, Star } from "lucide-react";
import { JEREMY, PHOTOS } from "@/lib/jeremy";

export default function Hero() {
  const phoneDigits = JEREMY.contact.phone.replace(/\D/g, "");
  return (
    <section className="relative overflow-hidden hero-gradient grain-overlay pt-28 md:pt-36 pb-20 md:pb-28" data-testid="home-hero">
      <div className="absolute inset-0 dot-grid opacity-40 pointer-events-none" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-12 gap-10 lg:gap-16 items-center relative">
        <div className="lg:col-span-7 text-[#F8FAFC] reveal-up">
          <div className="badge-pill mb-6" data-testid="hero-eyebrow">
            <Star className="w-3.5 h-3.5" /> Fredericksburg & Surrounding Virginia
          </div>
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-semibold leading-[1.05] tracking-tight">
            Could Solar Lower
            <br />
            <span className="italic text-[#FEF3C7]">Your Electric Costs?</span>
          </h1>
          <p className="mt-5 font-serif-display text-xl md:text-2xl text-[#FEF3C7]/90 italic" data-testid="hero-local-line">
            Personal solar guidance for Fredericksburg and surrounding Virginia communities.
          </p>
          <p className="mt-5 text-base md:text-lg leading-relaxed text-[#F8FAFC]/85 max-w-2xl">
            I'm Jeremy, a Navy veteran and authorized representative of ION Solar. I'll help you understand your electric bill, compare your current costs with a solar proposal, and decide whether solar makes sense for your home.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/qualify" className="btn-solar text-base" data-testid="hero-primary-cta">
              See If My Home Qualifies <ArrowRight className="w-4 h-4" />
            </Link>
            <a href={`tel:${phoneDigits}`} className="inline-flex items-center gap-2 px-6 py-[0.875rem] rounded-full font-semibold text-[#FDFBF7] hover:bg-[#FDFBF7]/10 transition-colors" style={{ border: "1.5px solid rgba(253,251,247,0.4)" }} data-testid="hero-talk-to-jeremy">
              <Phone className="w-4 h-4" /> Talk to Jeremy
            </a>
            <Link to="/qualify?upload=1" className="inline-flex items-center gap-2 px-6 py-[0.875rem] rounded-full font-semibold text-[#FEF3C7] hover:bg-white/10 transition-colors" data-testid="hero-upload-bill">
              <Upload className="w-4 h-4" /> Upload My Electric Bill
            </Link>
          </div>

          <p className="mt-6 text-xs text-[#F8FAFC]/60 max-w-xl">
            No-pressure consultation · Local Virginia guidance · Professional installation by ION Solar
          </p>
        </div>

        <div className="lg:col-span-5 relative reveal-up" style={{ animationDelay: "120ms" }}>
          <div className="relative">
            <div className="relative rounded-[2rem] overflow-hidden border-4 border-[#FEF3C7]/30 shadow-[0_40px_80px_-20px_rgba(0,0,0,0.65)]" style={{ background: "linear-gradient(160deg, #164E3D 0%, #0B261E 100%)" }}>
              <img
                src={PHOTOS.hero}
                alt="Jeremy — your local Virginia solar guide"
                className="w-full h-[540px] md:h-[640px] object-cover"
                style={{ objectPosition: "72% center" }}
                data-testid="hero-image-jeremy"
              />
              <div className="absolute bottom-4 left-4 right-4 rounded-2xl bg-[#FDFBF7]/95 backdrop-blur px-4 py-3 flex items-center justify-between gap-3">
                <div>
                  <div className="eyebrow">Jeremy · Fredericksburg</div>
                  <div className="font-serif-display text-base mt-0.5 text-[#0F382C] leading-tight">
                    "I'll help you decide, no pressure."
                  </div>
                </div>
                <a href={`tel:${phoneDigits}`} className="w-10 h-10 rounded-full bg-[#D97706] flex items-center justify-center shrink-0" data-testid="hero-call-jeremy" aria-label="Call Jeremy">
                  <Phone className="w-4 h-4 text-[#FDFBF7]" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
